<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("hardware", 2) }} {{ $tc("setting", 2) }}
      </div>
      <router-link class="btn-blue" to="hardware-settings"
        >{{ $tc("hardware", 2) }} {{ $tc("setting", 2) }}
        {{ $tc("list", 1) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <!-- CINEMA -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selected.cinema && selected.cinema.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >Cinema</label
                >
                <b-dropdown
                  :disabled="isRoleID"
                  :text="selected.cinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Cinema"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCinema()"
                      v-on:keydown="onSearchCinema()"
                      v-model="searchCinema"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(Cinema, CinemaIndex) in Cinemas"
                    :key="CinemaIndex"
                    v-on:click="onSelectCinema($event, Cinema, true)"
                    >{{ Cinema.cine_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>

              <!-- <Tooltip :title="$t('hardwareSettings_SelectCinema')" /> -->
            </div>
            <!-- <p class="error_message">
              <span v-if="submitted && selected.cinema.length == 0">{{ errmsg }}</span>
            </p> -->
          </div>

          <!-- UserName -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="hardwareSettingObject.hs_username"
                  type="text"
                  name="uname"
                  id="uname"
                  v-validate=""
                  placeholder="."
                />
                <label>{{ $t("username") }}</label>
              </div>
              <!-- <Tooltip :title="$t('hardwareSettings_Username')" /> -->
            </div>
            <!-- <p class="error_message">
              <span v-if="submitted && errors.has('uname')">{{ errors.first('uname') }}</span>
            </p> -->
          </div>

          <!-- PASSWORD -->
          <!-- <div class="col-md-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="hardwareSettingObject.hs_password"
                  type="password"
                  name="pwd"
                  id="pwd"
                />
                <label>{{ $t('password') }}</label>
              </div>
              <Tooltip :title="$t('hardwareSettings_Password')" />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>-->

          <!-- HARDWARE -->
          <div class="col-md-3">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selected.hardwareType && selected.hardwareType.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >Hardware Type</label
                >
                <b-dropdown
                  :text="selected.hardwareType"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Hardware"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchHardware()"
                      v-on:keydown="onSearchHardware()"
                      v-model="searchHardware"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(
                      HardwareTypes, HardwareTypesIndex
                    ) in HardwareTypesList"
                    :key="HardwareTypesIndex"
                    v-on:click="onSelectHardwareType($event, HardwareTypes)"
                    >{{ HardwareTypes.h_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>

              <!-- <Tooltip :title="$t('hardwareSettings_SelectedHardwareType')" /> -->
            </div>
            <!-- <p class="error_message">
              <span v-if="submitted && selected.hardwareType.length == 0">{{ errmsg2 }}</span>
            </p> -->
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedLocation ? 'shift-up' : ''">{{
                "Hardware Location"
              }}</label>
              <multiselect
                :options="HardwareLocations"
                v-model="selectedLocation"
                :searchable="true"
                label="location_name"
                track-by="hl_id"
                placeholder="."
                @select="onSelectHardwareLocation($event, 'select')"
                @remove="onSelectHardwareLocation($event, 'remove')"
              ></multiselect>
            </div>
            <p class="error_message"></p>
          </div>

          <!-- CPU ID -->
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-12 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      v-model="hardwareSettingObject.hs_cpu_id"
                      type="text"
                      name="ucode"
                      id="ucode"
                      placeholder="."
                    />
                    <label>{{ $t("hardwareuniquecode") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('hardwareSettings_HardwareUniqueCode')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="hardwareSettingObject.hs_hardware_name"
                  type="text"
                  name="hardwarename"
                  id="hardwarename"
                  v-validate="'required'"
                  placeholder="."
                />
                <!-- {required: 'required', regex:/^[a-zA-Z0-9 ]*$/} -->
                <label>{{ $tc("hardware", 2) }} {{ $t("name") }}</label>
              </div>
              <!-- <Tooltip :title="$t('hardwareSettings_HardwareName')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('hardwarename')">{{
                errors.first("hardwarename")
              }}</span>
            </p>
          </div>

          <!-- Connection Port -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="hardwareSettingObject.hs_connection_port"
                  type="text"
                  name="hardwareport"
                  v-validate=""
                  id="hardwareport"
                  placeholder="."
                />
                <!-- 'required|numeric' -->
                <label>{{ $t("connectionport") }}</label>
              </div>
              <!-- <Tooltip :title="$t('hardwareSettings_ConnectionPort')" /> -->
            </div>
            <!-- <p class="error_message">
              <span
                v-if="submitted && errors.has('hardwareport')"
              >{{ errors.first('hardwareport') }}</span>
            </p> -->
          </div>

          <!-- Installed BY -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="hardwareSettingObject.hs_installed_by"
                  type="text"
                  name="hardwareinstall"
                  id="hardwareinstall"
                  v-validate=""
                  placeholder="."
                />
                <!-- 'required|alpha_spaces' -->
                <label>{{ $t("installby") }}</label>
              </div>
              <!-- <Tooltip :title="$t('hardwareSettings_installBy')" /> -->
            </div>
            <!-- <p class="error_message">
              <span
                v-if="submitted && errors.has('hardwareinstall')"
              >{{ errors.first('hardwareinstall') }}</span>
            </p> -->
          </div>

          <!-- Hardware Remarks -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material-textarea">
                <textarea
                  v-model="hardwareSettingObject.hs_remarks"
                  rows="3"
                  name="hardwareremark"
                  id="hardwareremark"
                  v-validate=""
                ></textarea>
                <!-- 'required' -->
                <label
                  :class="
                    hardwareSettingObject.hs_remarks &&
                    hardwareSettingObject.hs_remarks.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("noteremarks") }}</label
                >
              </div>
            </div>
            <!-- <p class="error_message">
              <span
                v-if="submitted && errors.has('hardwareremark')"
              >{{ errors.first('hardwareremark') }}</span>
            </p> -->
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("hardwareIsDisabled") }}</label>
              <b-form-checkbox
                unchecked-value="N"
                v-model="hardwareSettingObject.hs_is_disabled"
                value="Y"
                name="check-button"
                switch
                class="j-checkbox"
              ></b-form-checkbox>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <b-form-checkbox
                unchecked-value="N"
                v-model="hardwareSettingObject.hs_is_active"
                value="Y"
                name="check-button"
                switch
                class="j-checkbox"
              ></b-form-checkbox>
            </div>
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-4">
            <div
              class="d-flex align-items-center"
              style="font-size: 13px; gap: 15px"
            >
              <label class="mb-0 font-weight-bold"
                >{{ "FNB Stock Deduction Settings" }}:</label
              >
              <b-form-radio
                :value="1"
                class="j-radio"
                v-model="hardwareSettingObject.hs_fnb_stock_settings"
              >
                <div>
                  <span>{{ "Normal" }}</span>
                </div>
              </b-form-radio>
              <!-- <strong class="mx-3">OR</strong> -->

              <b-form-radio
                :value="2"
                class="j-radio"
                v-model="hardwareSettingObject.hs_fnb_stock_settings"
              >
                <div>
                  <span>{{ "No Stock Deduction" }}</span>
                </div>
              </b-form-radio>

              <!-- <strong class="mx-3">OR</strong> -->

              <b-form-radio
                :value="3"
                class="j-radio"
                v-model="hardwareSettingObject.hs_fnb_stock_settings"
              >
                <div>
                  <span>{{ "Direct Stock Deduction" }}</span>
                </div>
              </b-form-radio>
            </div>
            <p class="error_message"></p>
          </div>

          <div class="col-md-12 text-center">
            <!-- <button
              @click.prevent.stop="onFinalSubmit(false)"
              class="btn-blue"
            >{{ $t('saveaddmore') }}</button>-->
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit(true)"
              class="btn-blue"
            >
              {{ $t("update") }}
            </button>
            <!-- <button @click.prevent.stop="onResetForm" class="btn-black">{{ $t('reset') }}</button> -->
            <b-button
              class="btn-outline-grey"
              variant="default"
              to="hardware-settings"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      HardwareTypesListCopy: [],
      searchHardware: "",
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      submitted: false,
      errmsg: "Please select cinema",
      errmsg1: "Please select hardware type",
      errmsg2: "",
      errmsg3: "",
      errmsg4: "",
      Cinemas: [],
      HardwareTypesList: [],
      Concessions: [],
      selected: {
        cinema: "",
        concessionLevel: "",
        keyName: "",
        hardwareType: "",
      },
      selectedLocation: "",
      HardwareLocations: [],
      hardwareSettingObject: {
        hs_id: null,
        cinema_id: null,
        hardware_location_id: null,
        concession_level_id: null,
        hs_fnb_stock_settings: 1,
        hardware_id: null,
        hs_username: "",
        // hs_password: "",
        hs_cpu_id: "",
        hs_remarks: "",
        hs_hardware_name: "",
        hs_connection_port: "",
        hs_is_active: "Y",
        hs_is_disabled: "N",
        hs_installed_by: "",
      },
      // Saif
      selectedKey: "",
      notesRemarks: "",
      validate: false,
      selectedCinema: "",
      selectedHardwareType: "",
    };
  },
  computed: {
    validStatus() {
      return this.validate ? true : false;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
    const { id } = this.$route.query;
    if (id) {
      this.getHardwareDetails(id);
      this.getHardwareTypesList();
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onSelectHardwareLocation(event, type = "select") {
      if (type == "select") {
        this.selectedLocation = event;
        this.hardwareSettingObject["hardware_location_id"] = event.hl_id;
      } else if (type == "remove") {
        this.selectedLocation = "";
        this.hardwareSettingObject["hardware_location_id"] = null;
      }
      this.$forceUpdate();
    },
    onSearchHardware: function () {
      if (this.searchHardware && this.searchHardware.length > 0) {
        this.HardwareTypesList = this.HardwareTypesListCopy.filter((x) => {
          if (
            x.h_name.toLowerCase().includes(this.searchHardware.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.HardwareTypesList = this.HardwareTypesListCopy;
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    setCinema: function (cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.Cinemas = data.Records;
            data.Records.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selected.cinema = x.cine_name;
                this.onSelectCinema(null, x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Err", err);
        }); //message
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.Cinemas.map(x => {
            //   if (String(cine_id) === String(x.cine_id)) {
            //     // this.selected.cinema = x.cine_name;
            //     this.onSelectCinema(null,x)
            //   }
            // });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Err", err);
        }); //message
    },
    getHardwareLocation(cinema_id, locationId) {
      this.HardwareLocations = [];
      if (cinema_id) {
        let payload = {
          cinema_id: cinema_id,
        };
        MasterService.getHardwarelocationByCinema(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.HardwareLocations = data.Records;
              if (locationId) {
                let tempArray = data.Records.filter(
                  (x) => x.hl_id == locationId
                );
                if (tempArray && tempArray.length > 0) {
                  this.onSelectHardwareLocation(tempArray[0], "select");
                }
              }
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error on getHardwareLocations :", error);
          });
      } else {
        this.HardwareLocations = [];
      }
    },
    getHardwareTypesList: function () {
      this.HardwareTypesList = [];
      let payload = {
        tableName: "ms_hardware",
        h_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.HardwareTypesList = data.Records;
            this.HardwareTypesListCopy = data.Records;
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Err", err);
        }); //message
    },
    getConcessionLevelList: function (cinema_id) {
      this.Concessions = [];
      // let payload = {
      //   tableName: "ms_concession_levels",
      //   cinema_id,
      //   cl_is_active: "Y"
      // };
      MasterService.GetConcessionByCinema({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Concessions = data.Records;
          } else {
            this.selected.concessionLevel = "";
            this.hardwareSettingObject.concession_level_id = null;
            // this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Err", err);
        }); //message
    },
    getHardwareDetails: function (hs_id) {
      let hardware_location_id = null;
      let cinema_id = null;
      CinemasService.GetHardwareSettignsById({ hs_id })
        .then((response) => {
          const { data } = response;
          console.log("data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.hardwareSettingObject = {
              ...this.hardwareSettingObject,
              ...data.Records[0],
            };
            hardware_location_id = data.Records[0].hardware_location_id;
            cinema_id = data.Records[0].cinema_id;
            this.selected = {
              cinema: data.Records[0].cine_name,
              concessionLevel: data.Records[0].cl_name,
              keyName: "Key",
              hardwareType: data.Records[0].h_name,
            };
            this.setCinema(data.Records[0].cinema_id);
            // this.getConcessionLevelList(data.Records[0].cine_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          this.getHardwareLocation(cinema_id, hardware_location_id);
        }); //message
    },
    onResetForm: function () {
      this.selected = {
        cinema: "",
        concessionLevel: "",
        keyName: "",
        hardwareType: "",
      };
      this.hardwareSettingObject = {
        hs_id: null,
        cinema_id: null,
        hardware_location_id: null,
        concession_level_id: null,
        hardware_id: null,
        hs_username: "",
        // hs_password: "",
        hs_cpu_id: "",
        hs_remarks: "",
        hs_hardware_name: "",
        hs_connection_port: 0,
        hs_is_active: "Y",
        hs_is_disabled: "N",
        hs_installed_by: "",
        hs_installed_at: new Date(),
        // hs_hardware_unique_id: null,
        created_at: null,
        created_by: null,
      };
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      console.log(
        "this.hardwareSettingObject :>> ",
        this.hardwareSettingObject
      );
      if (
        // !this.hardwareSettingObject.cinema_id &&
        // !this.hardwareSettingObject.hardware_id &&
        // !this.hardwareSettingObject.concession_level_id
        false
      ) {
        return;
        // this.$toasted.show("Please Select Cinema and Hardware Type");
      } else {
        this.$validator.validate().then((valid) => {
          if (valid) {
            this.btenable = true;
            CinemasService.UpdateHardwareSettigns(this.hardwareSettingObject)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  this.$toasted.show("Successfully Edited");
                  this.onResetForm();
                  if (redirect) {
                    this.$router.push({
                      path: "/cinema-manager/hardware-settings",
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      }
    },
    onSelectCinema: function (event, params, clear = false) {
      this.selected.cinema = params.cine_name;
      this.hardwareSettingObject.cinema_id = params.cine_id;
      this.hardwareSettingObject.cine_id = params.cine_id;
      if (clear) {
        this.selectedLocation = "";
        this.hardwareSettingObject["hardware_location_id"] = null;
      }
      this.getConcessionLevelList(params.cine_id);
      this.getHardwareLocation(params.cine_id);
      this.searchCinema = "";
      this.onSearchCinema();
    },
    onSelectHardwareType: function (event, params) {
      this.selected.hardwareType = params.h_name;
      this.hardwareSettingObject.hardware_id = params.h_id;
      this.searchHardware = "";
      this.onSearchHardware();
    },
    onSelectConcession: function (event, params) {
      this.selected.concessionLevel = params.cl_name;
      this.hardwareSettingObject.concession_level_id = params.cl_id;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/HardwaresComponents/editHardwareSetting.vue